<template>
  <div class="analysisreport-communicationTypeDetailReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <span class="mr10 fs14 color-666"
            >{{ $t("Analysisreport.cb") }}：</span
          >
          <div class="select-box" style="width: 260px">
            <el-date-picker
              v-model="filterList.rangTime"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmf00')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmzw0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fnis0')
              "
              :picker-options="pickerOptions"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10 Inquire-box">
          <div class="ipt-box" style="width: 280px">
            <el-input
              v-model="filter.keyword"
              clearable
              :placeholder="$t('Analysisreport.cc')"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelCrmDetailReport.51h4yx8fut40")
            }}</el-button
          >
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
export default {
  name: "analysisreport-communicationTypeDetailReport",
  data() {
    return {
      reportParams: {
        wayString: "courseRecruitCount", //传递到子组件的方法名称
        Title: "沟通类型明细表",
      },
      //筛选
      filter: {
        start_time: "",
        end_time: "",
        keyword: "", //关键词
      },
      // 筛选的下拉列表
      filterList: {
        rangTime: "",
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  updated() {},
  created() {
    this.filterList.rangTime = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.start_time = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.end_time = this.$Common.getAppointedDate(2, 0).endDate;
  },
  computed: {},
  methods: {
    //检索
    search() {
      this.filter.start_time = this.filterList.rangTime
        ? this.filterList.rangTime[0]
        : "";
      this.filter.end_time = this.filterList.rangTime
        ? this.filterList.rangTime[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
.analysisreport-communicationTypeDetailReport {
  .el-main {
    margin-bottom: 0px;
  }
}
</style>
